import { Channel, FormatMessageResponse } from 'stream-chat'

export class ChatService {
  static isChannelArchived = (channel: Channel) => {
    const channelArchiveDate = channel?.data?.archiveDate
      ? new Date(String(channel.data.archiveDate))
      : null

    const isChannelArchived =
      channelArchiveDate && channelArchiveDate < new Date()

    return !!isChannelArchived
  }

  // Single source of truth for which messages are hidden from chat surfaces.
  // Every surface (pane, list preview/timestamp, unread badges, sort, sound)
  // must derive from these helpers so they can't disagree (ENG-1452).
  static isSystemMessage = (
    message: { type?: string } | null | undefined
  ): boolean => message?.type === 'system'

  static getVisibleMessages = <T extends { type?: string }>(
    messages: T[]
  ): T[] => messages.filter(message => !ChatService.isSystemMessage(message))

  static getLastVisibleMessage = (
    channel: Channel
  ): FormatMessageResponse | undefined => {
    const messages = channel.state.messageSets?.[0]?.messages ?? []
    for (let i = messages.length - 1; i >= 0; i -= 1) {
      if (!ChatService.isSystemMessage(messages[i])) return messages[i]
    }
    return undefined
  }

  static countVisibleUnread = (
    channel: Channel,
    currentUserId: string
  ): number => {
    // An explicit lastRead forces the SDK to count loaded messages through
    // _countMessageAsUnread (which excludes system messages) instead of
    // returning the server-side state.unreadCount, which includes them.
    const lastRead =
      channel.state.read?.[currentUserId]?.last_read ?? new Date(0)
    return channel.countUnread(lastRead)
  }
}
